var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-result"},[_c('div',{staticClass:"uploadPng"}),_vm._v(" "),_c('p',{staticClass:"upload-tips"},[_vm._v("这里什么都没有哦")]),_vm._v(" "),(_vm.tabIndexs == 1)?_c('label',{staticStyle:{"height":"100%","width":"100%"},attrs:{"for":"audio"}},[_c('div',{staticClass:"uploadNow"},[_vm._v("立即上传")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29da7712","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subtitle/soundtrack/noUpload.vue
// module id = null
// module chunks = 